// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900);"]);
// Module
exports.push([module.id, ".v-data-footer[data-v-f56fddbc]{justify-content:center}.data-table__pre-header[data-v-f56fddbc]{border-bottom:1px solid var(--pale-sky-blue)}mark[data-v-f56fddbc]{background-color:var(--yellow-lighten-1)}mark.activeMatch[data-v-f56fddbc]{background-color:var(--orange-ligthen-1)}.scrollable-card[data-v-f56fddbc]{max-height:200px;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
